import {Card, CardContent, styled} from '@mui/material'
import {useEffect, useState} from 'react'
import AssistantTimelineView from '../timeline/AssistantTimelineView'
import {AssistantEventProducer} from '../timeline/AssistantEventProducer'
import AssistantActionManager from '../timeline/AssistantActionManager'
import {SessionItemData} from './Sessions'

const TimelineWrapper = styled(Card)(({theme}) => ({
  position: 'sticky',
  height: '100%',
  border: 0,
  paddingTop: '16px',
  [theme.breakpoints.up('md')]: {
    paddingTop: 0
  },
  '& > .MuiCardContent-root': {
    paddingTop: '0px',
    height: 'calc(100% - 1rem)',
    overflow: 'hidden'
  },
  [theme.breakpoints.down('md')]: {
    height: 'calc(100% - 58px)'
  }
}))

interface SessionsChatBoxProps {
  session: SessionItemData
  initMessage?: string
  isChatLocked?: boolean
}

const SessionsChatBox = ({
  session,
  initMessage,
  isChatLocked
}: SessionsChatBoxProps) => {
  const [producer, setProducer] = useState<AssistantEventProducer | undefined>(
    undefined
  )

  useEffect(() => {
    setProducer(
      new AssistantEventProducer(session, new AssistantActionManager())
    )
    // eslint-disable-next-line
  }, [session.id])

  useEffect(() => {
    return () => {
      producer?.complete()
    }
  }, [producer])

  return (
    <>
      {producer && (
        <TimelineWrapper>
          <CardContent>
            <AssistantTimelineView
              actionManager={producer.actionManager}
              producer={producer}
              hideMessageCreator={isChatLocked}
              scrollBarStyle="hidden"
              initMessage={initMessage}
            />
          </CardContent>
        </TimelineWrapper>
      )}
    </>
  )
}

export default SessionsChatBox
